import React from "react";
import { Col, Row, Select } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import { gendersList, TITLES } from "../../../../../../constants/common";
import CustomDatepicker from "../../../../../../common/input/custom-datepicker/custom-datepicker";

const TeacherInformation = ({ control }) => (
  <Row gutter={[32, 20]}>
    <Col span={12}>
      <Controller
        name="first_name"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomTextfield
            id="first_name"
            label="Teacher First Name"
            showRequired
            labelColor="#171717"
            placeholder="Enter first name"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          />
        )}
      />
    </Col>

    <Col span={12}>
      <Controller
        name="middle_name"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomTextfield
            id="middle_name"
            label="Middle Name"
            showOptional
            labelColor="#171717"
            placeholder="Enter middle name"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          />
        )}
      />
    </Col>
    
    <Col span={12}>
      <Controller
        name="last_name"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomTextfield
            id="last_name"
            label="Last Name"
            showRequired
            labelColor="#171717"
            placeholder="Enter last name"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          />
        )}
      />
    </Col>

    <Col span={12}>
      <Controller
        name="gender"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomSelect
            id="gender"
            label="Select Gender"
            showRequired
            labelColor="#171717"
            placeholder="--Select--"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          >
            {gendersList.map((item, index) => (
              <Select.Option key={index} value={item?.value}>
                {item?.label}
              </Select.Option>
            ))}
          </CustomSelect>
        )}
      />
    </Col>

    <Col span={12}>
      <Controller
        name="date_of_birth"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomDatepicker
            id="date_of_birth"
            label="Date Of Birth"
            showOptional
            labelColor="#171717"
            placeholder="DD-MM-YYYY"
            size="large"
            value={value}
            onChange={onChange}
            style={{ height: "40px", width: "100%" }}
            status={error ? "error" : ""}
            prefix={
              <img
                src="/assets/images/calendarOutlined.svg"
                style={{ marginRight: 4 }}
                alt="calendar"
              />
            }
          />
        )}
      />
    </Col>

    <Col span={12}>
      <Controller
        name="national_id"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomTextfield
            id="national_id"
            label="National ID Number"
            showOptional
            labelColor="#171717"
            placeholder="Enter Nation ID Number"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          />
        )}
      />
    </Col>

    <Col span={12}>
      <Controller
        name="title"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomSelect
            id="title"
            label="Select Title"
            showRequired
            labelColor="#171717"
            placeholder="--Select--"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          >
            {TITLES.map((item, index) => (
              <Select.Option key={index} value={item?.value}>
                {item?.label}
              </Select.Option>
            ))}
          </CustomSelect>
        )}
      />
    </Col>

    <Col span={12}>
      <Controller
        name="full_address"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomTextfield
            id="full_address"
            label="Full Address"
            showRequired
            labelColor="#171717"
            placeholder="Enter address"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          />
        )}
      />
    </Col>

    <Col span={12}>
      <Controller
        name="highest_degree"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomTextfield
            id="highest_degree"
            label="Enter Qualifications"
            showOptional
            labelColor="#171717"
            placeholder="Enter qualification"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          />
        )}
      />
    </Col>
  </Row>
);

export default TeacherInformation;
